import {
	Body,
	Container,
	Head,
	Html,
	Preview,
	Section,
} from "@react-email/components";
import Header from "./header";
import Footer from "./footer";

const styles = {
	body: {
		backgroundColor: "#fafafa",
		color: "#000000 !important",
		margin: "auto",
		width: "100%",
		textAlign: "center",
		fontFamily: "arial, 'helvetica neue', helvetica, sans-serif",
	},
	container: {
		width: "600px",
		backgroundColor: "#ffffff",
	},
	main: {
		padding: "10px 20px",
	},
};

export default function Layout({
	children,
	withNavBar,
	withCEOSignature,
	isInEmailList,
	utm_campaign,
	preview,
}) {
	return (
		<Html>
			<Head>
				<style
					type="text/css"
					dangerouslySetInnerHTML={{
						__html: "div .im {color: #000000 !important;}",
					}}
				/>
			</Head>
			<Preview>{preview}</Preview>
			<Body style={styles.body}>
				<Container style={styles.container}>
					<Header withNavBar={withNavBar} utm_campaign={utm_campaign} />
					<Section style={styles.main}>{children}</Section>
					<Footer
						withCEOSignature={withCEOSignature}
						isInEmailList={isInEmailList}
						utm_campaign={utm_campaign}
					/>
				</Container>
			</Body>
		</Html>
	);
}
